/* eslint-disable @typescript-eslint/no-explicit-any */
// src/store/appStore.ts
import { create } from "zustand"
import apiService from "@/services/apiService"

type AppStore = {
  _systemConfigs: any[]
  _filterOptions: any
  _notifications: any
  loading: boolean
  loadInitialData: () => Promise<void>
}

export const useAppStore = create<AppStore>((set) => ({
  _systemConfigs: [],
  _notifications: { data: [] },
  _filterOptions: {},
  loading: true,

  loadInitialData: async () => {
    try {
      const [systemConfigsRes, filterOptionsRes, notificationsRes] = await Promise.all([
        apiService.get("/system-configs"),
        apiService.get("/filter-options"),
        apiService.get("/notifications/today?unread=true")
      ])

      set({
        _systemConfigs: systemConfigsRes as any[],
        _filterOptions: filterOptionsRes as any,
        _notifications: notificationsRes as any[],
        loading: false
      })
    } catch (err) {
      console.error("API loading failed:", err)
      set({ loading: false })
    }
  }
}))
